import countries from "../../assets/countries.json";
import { arrayToObject, RouteLink } from "./links";

const _countries = countries as Country[];

interface State {
  code: string;
  name: string;
}

interface Country {
  code2: string;
  name: string;
  states: State[];
}

export const _countrLinks: RouteLink[] = _countries.map((e, i) => {
  return {
    label: e.code2.toLocaleLowerCase(),
    uri: e.name.toLocaleLowerCase(),
  };
});

export const countryObjs = arrayToObject(_countrLinks);
